import React, { useContext, useEffect, useRef, useState } from 'react';
import FormAddComment from '../../components/form/form-add-comment';
import CommentItem from '../../components/comment-item/comment-item';
import LoadingInCenter from '../../components/loading/loading-in-center';
import { useAlert } from 'react-alert';
import Svg from '../../components/icons/svg';
import api from '../../../api/api';
import { AdminContext } from '../../../context/admin-context';
import { MemberContext } from '../../../context/member-context';
import { Link } from 'react-router-dom';

import './comment-style.css';

const Comments = (props) => {
  const { data, postProvider } = props;
  const admin = useContext(AdminContext);
  const member = useContext(MemberContext);

  function handleBackButton() {
    postProvider.hideCommentsArea();
  }

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ //
  const p = {};
  const [moreLoading, setMoreLoading] = useState(false);
  const [commentPage, setCommentPage] = useState(1);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [requestSending, setRequestSending] = useState(false);
  const [comments, setComments] = useState({ list: data.comments.list });
  const [hasMore, setHasMore] = useState(data.comments.hasMore);
  const [repliesId, setRepliesId] = useState(0);
  const [showLoginRequired, setShowLoginRequired] = useState(false);
  const inputRef = useRef();
  const alert = useAlert();
  const inputSimulator = document.createElement('textarea');

  p.inputRef = inputRef;
  p.formSubmit = (e) => {
    e.preventDefault();
    formSubmit();
  };

  p.submitDisabled = submitDisabled;
  p.setSubmitDisabled = (value) => {
    setSubmitDisabled(value);
  };

  p.repliesId = repliesId;
  p.addReplies = (id) => {
    setRepliesId(id);
    p.handleClickOnInput();
  };
  p.removeComment = (id) => {
    removeComment(id);
  };
  p.removeReplies = (id) => {
    removeReplies(id);
  };
  p.cancelReplies = () => {
    setRepliesId(0);
  };

  p.hasMore = hasMore;
  p.moreLoading = moreLoading;
  p.requestSending = requestSending;

  p.handleClickOnInput = () => {
    if (admin.auth.value || member.auth.value) {
      inputRef.current.focus();
    } else {
      setShowLoginRequired(true);
      inputRef.current.blur();
    }
  };

  p.handleClickOnSubmit = (e) => {
    if (admin.auth.value === false && member.auth.value === false) {
      e.preventDefault();
      setShowLoginRequired(true);
    }
  };

  const handleCloseLoginRequired = () => {
    setShowLoginRequired(false);
  };

  const handleSetRedirect = () => {
    member.setRedirect(`post/${data.id}`);
  };

  const inputOnChange = () => {
    setTimeout(() => {
      if (inputRef.current) {
        // Wen close comment area, inputRef will be destroyed. So we must check inputRef existing after 10ms.
        inputSimulator.value = inputRef.current.value;

        const height = inputSimulator.scrollHeight < 80 ? inputSimulator.scrollHeight : 80;
        inputRef.current.style.height = height + 'px';

        if (height === 80) {
          inputRef.current.classList.remove('o-hidden');
          inputRef.current.classList.add('o-auto');
        } else {
          inputRef.current.classList.remove('o-auto');
          inputRef.current.classList.add('o-hidden');
        }

        if (inputRef.current.value.length > 0) {
          setSubmitDisabled(false);
        } else {
          setSubmitDisabled(true);
        }
      }
    }, 0);
  };

  const formSubmit = () => {
    const value = inputRef.current.value;

    if (value.length <= 4200000000) {
      /*
            in sm mode: first run formSubmit function and then run inputOnChange function.
            so use setTimeOut to setSubmitDisabled(true) set after function inputOnChange complete.
             */
      setTimeout(() => {
        setSubmitDisabled(true);
      }, 0);
      setRequestSending(true);

      const apiData = {
        post_id: data.id,
        content: value,
      };
      if (repliesId) {
        apiData.replies = repliesId;
      }

      api.comment
        .add(apiData)
        .then((response) => {
          const status = response && response.status;
          const message = response && response.message;
          const id = response && response.id;
          if (status === 'ok') {
            if (repliesId) {
              const patchReply = (list) =>
                list.map((item) => (String(item.id) === String(repliesId) ? { ...item, replies: value } : item));

              setComments((prevData) => ({
                ...prevData,
                list: patchReply(prevData.list),
              }));
              postProvider.setNewComments((prevState) => ({
                ...prevState,
                list: patchReply(prevState.list),
              }));

              setRepliesId(0);
            } else if (id) {
              const created = {
                id: id,
                content: value,
                replies: null,
                member_id: member.auth.value ? member.info.id : null,
                fullname: member.auth.value ? member.info.fullname : null,
                avatar: member.auth.value ? member.info.avatar : null,
              };
              postProvider.setNewComments((prevState) => ({
                ...prevState,
                list: [created, ...prevState.list],
              }));
            }

            inputRef.current.value = null;
          } else {
            alert.error(Array.isArray(message) ? message.join(' ') : message || 'ارسال نظر با خطا مواجه شد');
            setSubmitDisabled(false);
          }

          setRequestSending(false);
        })
        .catch(() => {
          alert.error('ارسال نظر با خطا مواجه شد');
          setSubmitDisabled(false);
          setRequestSending(false);
        });
    } else {
      alert.error(
        <>
          <p>نظر شما نباید بیشتر از 4200000000 کاراکتر باشد.</p>
          <p>طول فعلی : {value.length}</p>
        </>,
      );
    }
  };

  const removeComment = (id) => {
    const callBack = (response) => {
      const { status, message } = response;

      if (status === 'ok') {
        let removedFromCommentList = false;
        const list = comments.list;
        for (let i = 0; i < list.length; i++) {
          if (list[i].id === id) {
            list.splice(i, 1);
            setComments((prevData) => {
              const update = {
                list: list,
              };

              return { ...prevData, ...update };
            });
            postProvider.setRemoveCount(postProvider.removeCount + 1);
            removedFromCommentList = true;
            break;
          }
        }

        if (removedFromCommentList === false) {
          const _list = postProvider.newComments.list;
          for (let i = 0; i < _list.length; i++) {
            if (_list[i].id === id) {
              _list.splice(i, 1);
              postProvider.setNewComments((prevData) => {
                const update = {
                  list: _list,
                };

                return { ...prevData, ...update };
              });
              break;
            }
          }
        }
      } else if (status === 'error') {
        alert.error(message);
      }
    };

    if (member.auth.value) {
      api.member.removeComment({ id }).then((response) => {
        callBack(response);
      });
    } else {
      api.comment.remove({ id }).then((response) => {
        callBack(response);
      });
    }
  };

  const removeReplies = (id) => {
    api.comment.removeReplies({ id }).then((response) => {
      const { status, message } = response;

      if (status === 'ok') {
        setComments((prevData) => {
          const list = prevData.list;
          for (let i = 0; i < list.length; i++) {
            if (list[i].id === id) {
              list[i].replies = null;
              break;
            }
          }
          const update = {
            list: list,
          };

          return { ...prevData, ...update };
        });
      } else if (status === 'error') {
        alert.error(message);
      }
    });
  };

  const loadMoreComment = () => {
    setMoreLoading(true);

    const apiData = {
      post_id: data.id,
      p: commentPage,
      shift: postProvider.newComments.list.length,
      unshift: postProvider.removeCount,
    };

    api.comment.get(apiData).then((response) => {
      const { status, message, list, hasMore } = response;

      if (status === 'error') {
        alert.error(message);
      } else {
        if (list && list.length > 0) {
          const newList = comments.list.concat(list);
          setComments((prevComments) => {
            const update = {
              list: newList,
            };
            return { ...prevComments, ...update };
          });
        }
      }

      setCommentPage(commentPage + 1);
      setHasMore(hasMore);
      setMoreLoading(false);
    });
  };

  const init = () => {
    if (inputRef.current) {
      inputRef.current.addEventListener('keydown', inputOnChange);
      inputRef.current.addEventListener('input', inputOnChange);
      inputRef.current.addEventListener('change', inputOnChange);
      inputSimulator.style.cssText = `width: ${inputRef.current.offsetWidth}px; height: 19px; padding: 0;`;
      inputSimulator.classList.add('simulator-textarea');
      document.body.appendChild(inputSimulator);
    }
  };
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ //

  useEffect(() => {
    document.title = document.title + ' • ' + 'نظرات';
    document.body.classList.add('sm-comments');

    init();

    return () => {
      inputSimulator.remove();
      document.body.classList.remove('sm-comments');
    };
  }, []);

  return (
    <div className="p-fixed f-grow-1 wh-100 sm-comment-area">
      <header className="head-nav">
        <div className="fb-fix" />
        <div className="nav align-items-center">
          <div className="d-flex f-row align-items-center justify-content-end">
            <div className="btns d-flex f-row justify-content-start align-items-center align-content-center f-wrap-wrap f-100">
              <h4>نظرات</h4>
            </div>
            <div onClick={handleBackButton} className="c-p">
              <span className="d-inline-block" style={{ transform: 'rotate(270deg)' }}>
                <Svg name={'angleTop'} width={24} height={24} fill={'#262626'} label={'Back'} />
              </span>
            </div>
          </div>
        </div>
      </header>

      <section className="comment-form f-shrink-0 justify-content-center">
        <div className="form-area f-shrink-0 justify-content-center">
          <FormAddComment provider={p} />
        </div>
      </section>

      <div className="f-11auto">
        <ul className="comments-area h-100 f-grow-1 bs-content-box oy-scroll p-absolute r-0">
          {data.description?.length > 0 && (
            <div className="post-description">
              <span className="font-size-4 line-height-3">
                {data.description &&
                  data.description.split('\n').map((str, i) => {
                    return (
                      <React.Fragment key={str + i}>
                        {str}
                        <br />
                      </React.Fragment>
                    );
                  })}
              </span>
            </div>
          )}

          {postProvider.newComments.list.map((comment) => {
            return <CommentItem provider={p} comment={comment} key={comment.id} />;
          })}

          {comments.list.map((comment) => {
            return <CommentItem provider={p} comment={comment} key={comment.id} />;
          })}

          {p.hasMore && p.moreLoading && (
            <div className="p-relative mr-n16p">
              <button className="load-more-plus f-grow-0 d-flex">
                <LoadingInCenter show={true} label={'Comment Loading'} fill={'#555555'} width={24} height={24} />
              </button>
            </div>
          )}
          {p.hasMore && !p.moreLoading && (
            <li className="mr-n16p">
              <div className="p-relative">
                <button
                  className="load-more-plus f-grow-0 d-flex justify-content-center align-items-center c-p"
                  onClick={loadMoreComment}
                >
                  <span className="glyphsSpriteCircle_add__outline__24__grey_9" aria-label="Load more comments" />
                </button>
              </div>
            </li>
          )}
        </ul>
      </div>

      {showLoginRequired && (
        <div className="alert-login-required align-content-stretch align-items-center justify-content-center">
          <div className="body align-items-center">
            <p className="mb-26p font-size-4 text-center">برای ارسال نظر باید وارد حساب کاربری خود شوید</p>
            <div className="f-row w-100 justify-content-around">
              <Link to={'/member/login'} className="btn-primary font-size-4" onClick={handleSetRedirect}>
                ورود به حساب
              </Link>
              <button type="button" className="text-danger c-p font-size-4" onClick={handleCloseLoginRequired}>
                بازگشت
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Comments;
